import { HubDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { HubDetailsActions } from '../actions/hub-details.actions';
import { DisableHubModal } from '../../actions/components/disable-hub-modal.component';
import { EnableHubModal } from '../../actions/components/enable-hub-modal.component';
import { DeleteHubModal } from '../../actions/components/delete-hub-modal.component';
import { OpenAllHubModal } from '../../actions/components/open-all-hub-modal.component';
import { SyncHubDataModal } from '../../actions/components/sync-data-hub-modal.component';
import { RemoteViewerModal } from '../../actions/components/remote-viewer/remote-viewer-modal.component';
import { Snackbar } from '../../../../ui/components/pure/snackbar/snackbar.component';

export function HubDetailsActionsObserver({
  hub,
  actions,
  projectID
}: {
  hub: HubDto;
  actions: { currentAction: HubDetailsActions | null; setAction: (action: HubDetailsActions | null) => void };
  projectID: string;
}) {
  if (actions.currentAction === null) {
    return null;
  }

  switch (actions.currentAction) {
    case HubDetailsActions.OPEN_ALL:
      return (
        <OpenAllHubModal
          hubID={hub.id}
          onSuccess={() => actions.setAction(null)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case HubDetailsActions.ENABLE:
      return (
        <EnableHubModal
          hub={hub}
          projectID={projectID}
          onSuccess={() => actions.setAction(null)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case HubDetailsActions.DISABLE:
      return (
        <DisableHubModal
          hub={hub}
          projectID={projectID}
          onSuccess={() => actions.setAction(null)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case HubDetailsActions.DELETE:
      return (
        <DeleteHubModal
          hub={hub}
          projectID={projectID}
          onSuccess={() => actions.setAction(null)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case HubDetailsActions.SYNC_KIOSK_DATA:
      return (
        <SyncHubDataModal
          hub={hub}
          onSuccess={() => actions.setAction(HubDetailsActions.SYNC_KIOSK_DATA_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case HubDetailsActions.SYNC_KIOSK_DATA_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Data sync has been initiated. This process may take up to 5 minutes.
        </Snackbar>
      );
    case HubDetailsActions.REMOTE_VIEWER:
      return <RemoteViewerModal hub={hub} projectID={projectID} onClose={() => actions.setAction(null)} />;
    default:
      return null;
  }
}
